import { camelCase } from 'lodash';
import { deepMapKeys } from '../utils/commonUtil';
import { createHttpClient } from './createHttpClient';

export type { HttpInit, HttpResponse } from './createHttpClient';

// axios の既定値と同じ。*/* を含むと Rails はブラウザ扱いで Accept を無視し、
// request.format を拡張子から決める。application/json だけにすると全エンドポイントが json 扱いに変わる
const ACCEPT = 'application/json, text/plain, */*';

export function csrfToken(): string {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content ?? ''
  );
}

// この Rails アプリの API を呼ぶクライアント
export const http = createHttpClient({
  headers: url => {
    const headers = new Headers({ Accept: ACCEPT });
    // 案件コピー元など別オリジンの baseUrl に、このサイトの CSRF トークンを渡さない
    if (url.origin === location.origin) {
      headers.set('X-CSRF-Token', csrfToken());
    }
    return headers;
  },
  // サーバーが snake_case で返すため、成功時だけ camelCase にする
  transformData: data =>
    typeof data === 'object' && data !== null
      ? deepMapKeys(data as Record<string, unknown>, camelCase)
      : data,
});
